import styled from 'styled-components/macro'
import { Form } from '@resultadosdigitais/tangram-components'

const StyledForm = styled(Form)`
  box-shadow: var(--shadow-sm);
  padding: var(--size-spacing-07);
  background: var(--color-white);
  border-radius: var(--border-radius-rounded);
  will-change: opacity, transform;
  width: 100%;
  margin-top: var(--size-spacing-05);

  > * + * {
    margin-top: var(--size-spacing-04);
  }

  @media screen and (min-width: 768px) {
    margin-top: var(--size-spacing-02);
  }
`

export default StyledForm
